export default "__VITE_ASSET__ddf6e715__"